import CaseSettingsClient from './CaseSettingsClient';
import HttpClient from '../../../gateway/HttpClient';
import { notBlank, notUndefined } from '../../../util/Assert';
import { CaseSettings } from '../../../domain/case/CaseDomains';
import HttpMethod from '../../../constant/HttpMethod';
import { AlarmSettingsMethods } from '../../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import CaseActionUtil from '../../../util/CaseActionUtil';

class NestCaseSettingsClient implements CaseSettingsClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public remove(domainName: string): Promise<void> {
    notUndefined(domainName, 'Domain name cannot be undefined');
    notBlank(domainName, 'Domain name cannot be blank');
    return this.httpClient.execute(HttpMethod.DELETE, `${AlarmSettingsMethods.REMOVE}/${domainName}`);
  }

  public save(domain: CaseSettings): Promise<void> {
    notUndefined(domain, 'Domain cannot be undefined');
    const dto = { id: domain.name, object: domain };
    return this.httpClient.execute(HttpMethod.POST, AlarmSettingsMethods.SAVE, dto);
  }

  public async get(domainName: string): Promise<CaseSettings> {
    notUndefined(domainName, 'Domain name cannot be undefined');
    notBlank(domainName, 'Domain name cannot be blank');
    const settings = await this.httpClient.execute<CaseSettings>(HttpMethod.GET, `${AlarmSettingsMethods.GET_SETTING}/${domainName}`);
    return CaseActionUtil.normalizeCaseSettingsActions(settings) as CaseSettings;
  }

  public async getByChannel(channel: string): Promise<CaseSettings | undefined> {
    notUndefined(channel, 'Channel name cannot be undefined');
    notBlank(channel, 'Channel name cannot be blank');
    const settings = await this.httpClient.execute<CaseSettings | undefined>(HttpMethod.GET, `${AlarmSettingsMethods.GET_SETTING_BY_CHANNEL}/${channel}`);
    if (!settings) {
      return undefined;
    }
    return CaseActionUtil.normalizeCaseSettingsActions(settings) as CaseSettings;
  }

  public count(_query: query.Query): Promise<number> {
    notUndefined(_query, 'Query cannot be undefined');
    return this.httpClient.execute(HttpMethod.POST, AlarmSettingsMethods.COUNT, _query);
  }
}

export default NestCaseSettingsClient;
